import { Button, colors, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material';
import React from 'react';
import HTMLEditor from '../../components/HTMLEditor';

const DialogHTMLEditor = ({ dialogMetadata, handleClose, answers, setAnswers }) => {
  const [state, setState] = React.useState({ value: '' });

  const handleSave = () => {
    setAnswers({ ...answers, [dialogMetadata.tag]: { value: state.value } });
    handleClose();
  };

  return (
    <Dialog maxWidth='lg' open={dialogMetadata.status} onCLose={handleClose}>
      <DialogTitle>HTML Editor</DialogTitle>
      <DialogContent>
        <DialogContentText>Please insert the content using the rich text editor below then click save:</DialogContentText>

        <Stack direction='column' spacing={1} mt={2}>
          <HTMLEditor state={state} setState={setState} currentHtml={answers[dialogMetadata.tag]?.value ? answers[dialogMetadata.tag]?.value : ''} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack m={2} direction='row' spacing={1}>
          <Button onClick={handleClose} sx={{ backgroundColor: colors.red[400], width: 80 }} variant='contained'>
            Cancel
          </Button>
          <Button onClick={handleSave} sx={{ width: 80 }} variant='contained'>
            Save
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default DialogHTMLEditor;
